module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--bg-378fe000d99d82110ad4a857afc814cc.jpg";